import styled from 'styled-components';
import PropTypes from 'prop-types';

const Checkbox = ({ label, checked, onChange }) => {
  const handleChange = e => {
    e.preventDefault();
    if (onChange) onChange(!checked);
  };

  return (
    <CheckboxContainer checked={checked} onClick={handleChange}>
      {label}
      <input type='checkbox' />
      <span />
    </CheckboxContainer>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default Checkbox;

const CheckboxContainer = styled.label`
  display: block;
  position: relative;
  padding-left: 1.6rem;
  padding-top: 0.125rem;
  cursor: pointer;
  user-select: none;
  margin-right: 0.5rem !important;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    height: 1.375rem;
    width: 1.375rem;
    background-color: ${({ checked }) => (checked ? '#00c2ff' : '#dfecf4')};
    border: 2px solid #6e84be;

    &:hover {
      background-color: ${({ checked }) => (checked ? '#00c2ff' : '#d3e5f1')};
    }

    &:after {
      content: '';
      position: absolute;
      display: ${({ checked }) => (checked ? 'block' : 'none')};
      left: 3px;
      top: 2px;
      width: 4px;
      height: 8px;
      border: solid #fff;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
    }
  }
`;
